// removed by extract-text-webpack-plugin
module.exports = {"contact":"src-pages----contact-module---contact---3yNwE","contactForm":"src-pages----contact-module---contactForm---1o6S7","back":"src-pages----contact-module---back---2OJLR","formInput":"src-pages----contact-module---formInput---2hfyc","label":"src-pages----contact-module---label---CYDel"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/contact.module.css
// module id = 351
// module chunks = 70144966829960